module.exports = __webpack_public_path__ + "img/X.859c2a2c.png";